const fragShader = `
precision mediump float;
uniform float iTime;
uniform vec2 iResolution;
uniform sampler2D iChannel0;
uniform sampler2D uMainSampler;
uniform vec2 uTextureCenter; // Новая uniform переменная для центра текстуры

varying vec2 outTexCoord;

#define iterations 17
#define formuparam 0.53

#define volsteps 20
#define stepsize 0.1

#define zoom   0.800
#define tile   0.850
#define speed  0.0001 

#define brightness 0.0015
#define darkmatter 0.300
#define saturation 0.850

#define R iResolution.xy
#define M cos(iTime)
#define H(a) (cos(radians(vec3(0, 60, 120))+(a)*6.2832)*.5+.5)  // hue
#define N(r) ((abs(r) > 1.) ? 1./(2.*sign(r)-(r)): r)  // range +/-2 to value on the number line

mat2 rotate2D(float r) {
    return mat2(cos(r), sin(r), -sin(r), cos(r));
}

void mainVR(out vec4 fragColor, in vec2 fragCoord, in vec3 ro, in vec3 rd) {
    float s = 0.1, fade = 1.;
    vec3 v = vec3(0.);
    
    for (int r = 0; r < volsteps; r++) {
        vec3 p = ro + s * rd * 0.5;
        p = abs(vec3(tile) - mod(p, vec3(tile * 2.))); // tiling fold
        float pa, a = pa = 0.;
        
        for (int i = 0; i < iterations; i++) { 
            p = abs(p) / dot(p, p) - formuparam;
            a += abs(length(p) - pa); // absolute sum of average change
            pa = length(p);
        }
        
        a *= a * a; // add contrast
        
        v += vec3(s, s * s, s * s * s * s) * a * brightness * fade;
        fade *= 0.95; // Измененный коэффициент затемнения
        s += stepsize;
    }
    
    fragColor = vec4(v * 0.033, 1.);
}

float cheap_star(vec2 uv, float anim) {
    uv = abs(uv);
    vec2 pos = min(uv.xy / uv.yx, anim);
    float p = (2.0 - pos.x - pos.y);
    return (2.0 + p * (p * p - 1.5)) / (uv.x + uv.y);
}

void mainImage(out vec4 fragColor, in vec2 fragCoord) {
    vec4 startColor = texture2D(uMainSampler, outTexCoord);
    vec2 uv = (outTexCoord * 2.0 - 1.0) * iResolution.y / iResolution.xy;
    uv.x -= uTextureCenter.x - 0.25; // Учтено смещение центра текстуры
    uv.y -= uTextureCenter.y - 0.25;
    vec3 dir = vec3(uv * zoom, iTime * 0.01);

    float time = iTime * speed + 0.25;
    vec3 from = vec3(1., .5, 0.5);
    from += vec3(time * 2., time, -2.);

    mainVR(fragColor, fragCoord, from, dir);
    fragColor *= vec4(cheap_star(uv, 1.0) * vec3(19.5, 17.8, 17.8) * 10.0, fragColor.a) * startColor;
    fragColor = vec4(fragColor.r, fragColor.g, fragColor.b, fragColor.a);
}

void main()
{
    mainImage(gl_FragColor, gl_FragCoord.xy);
}
`;

export class GlowPipeline1 extends Phaser.Renderer.WebGL.Pipelines.SinglePipeline {
    constructor(game) {
        super({
            game,
            fragShader,
            uniforms: ['iTime', 'iResolution', 'uTextureCenter', 'iChannel0', 'uMainSampler']
        });
    }

    onPreRender() {
        this.set1f('iTime', this.game.loop.time / 4000);
        this.set2f('iResolution', this.renderer.width * 3, this.renderer.height);
        this.set2f('uTextureCenter', this.renderer.width / 2, this.renderer.height / 2);
        this.set1i('iChannel0', 0);
    }
}
